import React, { useEffect } from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Display',
  },
  {
    path: 'Accordions',
    breadcrumbName: 'Accordions',
  },
];
const Accordions_ = () => {
  useEffect(() => {
    new IMI.Accordions(document.querySelector('[data-rule="accordion"]'));
  }, []);

  return (
    <>
      <PageHeader title="Accordions-FAQ" breadcrumb={{ routes }} subTitle="Accordions" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="accordion" data-rule="accordion">
          <div className="title">accordion</div>
          <div className="content">accordion<br/>accordion<br/>accordion<br/>accordion<br/>accordion</div>
          <div className="title">accordion2</div>
          <div className="content">accordion2</div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div className="accordion" data-rule="accordion">
    <div className="title"> <!-- Q --> </div>
    <div className="content"> <!-- A --> </div>
    <div className="title"> <!-- Q --> </div>
    <div className="content"> <!-- A --> </div>
    <div className="title"> <!-- Q --> </div>
    <div className="content"> <!-- A --> </div>
</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>


    </>
  );
}

export default Accordions_;
